export default {
  denimBlue: '#2c6b8c', // ButtonHover-Blue-Denim
  curiousBlue: '#3f9ac9', // ButtonActive-Curious Blue
  whiteSmoke: '#f5f5f5', // PrimaryButton Disable white smoke
  grayDisableBorder: '#d9d9d9', // PrimaryButton Disable-border-color
  blackColor: 'rgba(0, 0, 0, .65)',
  blackColorLightShade: 'rgba(0, 0, 0, 0.8)',
  blackShade: 'rgba(0, 0, 0, 0.25)',
  lightGray: 'rgba(230, 230, 230, 0.8)',
  lightningYellowIcon: '#F5A623', // warning icon color F5A623
}
